import React from "react";
import { createSvgIcon } from "@mui/material/utils";
const EllipsisVertical = createSvgIcon(/*#__PURE__*/React.createElement("path", {
  d: "M12,7a2,2,0,1,0-2-2A2,2,0,0,0,12,7Zm0,10a2,2,0,1,0,2,2A2,2,0,0,0,12,17Zm0-7a2,2,0,1,0,2,2A2,2,0,0,0,12,10Z"
}), "EllipsisVertical");
export default EllipsisVertical;